module.exports = __webpack_public_path__ + "media/elefant_m.7679e795.mp3";